/* Simple Snowfall Animation for Announcement Bar */
document.addEventListener('DOMContentLoaded', () => {
    const announcementBar = document.querySelector('.announcement-bar-component') || document.querySelector('.announcement-bar');

    if (announcementBar) {
        // Function to create a single snowflake
        function createSnowflake() {
            const snowflake = document.createElement('span');
            snowflake.classList.add('snowflake');

            // Randomize starting position and size
            const size = Math.random() * 5 + 2; // 2px to 7px
            const startX = Math.random() * 100; // 0% to 100% width
            const duration = Math.random() * 10 + 5; // 5s to 15s fall time

            snowflake.style.width = `${size}px`;
            snowflake.style.height = `${size}px`;
            snowflake.style.left = `${startX}%`;
            snowflake.style.animationDuration = `${duration}s`;
            snowflake.style.opacity = Math.random() * 0.7 + 0.3; // Random opacity

            announcementBar.appendChild(snowflake);

            // Remove snowflake after it falls to prevent overflow
            setTimeout(() => {
                snowflake.remove();
            }, duration * 1000);
        }

        // Generate snow for the bar
        const snowCount = 100; // Number of snowflakes
        for (let i = 0; i < snowCount; i++) {
            setTimeout(createSnowflake, Math.random() * 5000); // Stagger the start time
        }
        
        // Keep generating new snow every 100ms
        setInterval(createSnowflake, 100);
    }
});
